import { useContext, useRef } from "react"
import { find, isEqual } from "lodash"
import { useSnackbar } from "notistack"
import { useMutation } from "react-query"
import { useParams } from "react-router-dom"

import useAxiosPrivate from "./useAxiosPrivate.js"
import useFetchEntities from "./useFetchEntity.js"
import AuthContext from "../Context/auth_provider.jsx"

const useAddMembers = () => {
    const { enqueueSnackbar } = useSnackbar()
    const axiosPrivate = useAxiosPrivate()
    const { tId } = useParams()
    const { companyId, teamId } = useContext(AuthContext)

    const endPoint = tId ? `team/${tId}/prerides` : "prerides"
    const domain = teamId ? `/team/${teamId}` : `/corporate/${companyId}`
    const assignUrl = tId
        ? `${domain}/team/${tId}/preride/assign`
        : `${domain}/preride/assign`
    const companyPrograms = useFetchEntities(endPoint)

    const assign = useRef([])

    const { mutate, isLoading } = useMutation((data) =>
        axiosPrivate.post(assignUrl, {
            pre_ride_users: data,
        })
    )

    const handleAssign = (value) => {
        // BACKEND DOESN'T ACCEPT PROGRAM NAME, ONLY PROGRAM ID
        const programIds = value.programs
            ?.split(",")
            ?.map((e) => e.trim())
            ?.map(
                (prog) =>
                    companyPrograms?.data?.data?.data?.filter(
                        (ele) => ele.name === prog
                    )[0].id
            )
        // BACKEND DOESN'T ACCEPT AN ARRAY OF VALUES FOR PROGRAMIDS SO, FLATTEN THE ARRAY
        programIds?.forEach((id) => {
            const val = {
                user_id: value.userId,
                pre_ride_id: id,
            }

            if (find(assign.current, (el) => isEqual(el, val))) return
            assign.current = [...assign.current, val]
        })
    }

    return {
        assignUser: handleAssign,
        isLoading,
        requestAssign: (callback) => {
            if (assign.current.length === 0) {
                enqueueSnackbar(
                    "None of the people are on ridePlus, make sure to invite them",
                    {
                        variant: "warning",
                    }
                )
                return
            }
            mutate(assign.current, {
                onSuccess: () => {
                    enqueueSnackbar("Program Assigned Successfully", {
                        variant: "success",
                    })
                    callback()
                },
                onError: (error) => {
                    const fieldError =
                        error.response?.data?.error?.field_error[0]?.description
                    const errorMessage = error.response?.data?.error?.message
                    enqueueSnackbar(
                        fieldError || errorMessage || "Request Failed",
                        { variant: "error" }
                    )
                },
            })
        },
        clearAssign: () => {
            assign.current = []
        },
    }
}

export default useAddMembers
